import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { Link } from "react-router-dom";
import { Position } from "@/services/positionService";

interface PositionsTableProps {
  tableTypes?: Position[];
}

export function PositionsTable({ tableTypes }: PositionsTableProps) {
  // Sort the table types alphabetically by tableName if tableTypes exists
  const sortedTableTypes = tableTypes
    ? [...tableTypes].sort((a, b) => a.tableName.localeCompare(b.tableName))
    : [];

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Table Type</TableHead>
          <TableHead>Price ($)</TableHead>
          <TableHead>Employees Required</TableHead>
          <TableHead>Dealer Pay ($)</TableHead>
          <TableHead>Multiple Assignments</TableHead>
          <TableHead>Overlapping Events</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sortedTableTypes.map((table) => (
          <TableRow key={table.id}>
            <TableCell>{table.tableName}</TableCell>
            <TableCell>{table.billPrice}</TableCell>
            <TableCell>{table.employeesRequired}</TableCell>
            <TableCell>{table.employeePay}</TableCell>
            <TableCell>
              <Checkbox checked={table.allowsMultipleAssignments} disabled />
            </TableCell>
            <TableCell>
              <Checkbox checked={table.allowsOverlappingEvents} disabled />
            </TableCell>
            <TableCell className="text-right">
              <Link to={`/admin/pricing/${table.id}/edit`}>
                <Button variant="outline" size="sm">
                  <Pencil className="h-4 w-4 mr-1" />
                  Edit
                </Button>
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
